import React from 'react';
import { Button } from '@myua/kit';
import { useSelector, useDispatch } from 'react-redux';
import { getExpandedMode } from '../selectors';
import * as tagActions from '../actions';
import { ArrowUp1, ArrowDown } from '@myua/icons/dist/linear16';

export const TagsExpandedModeButton = () => {
  const dispatch = useDispatch();
  const expandedMode = useSelector(getExpandedMode);
  return (
    <Button
      className="al-tags-expanded-mode"
      onClick={() => dispatch(tagActions.expandedModeChanged({ expandedMode: !expandedMode }))}
      icon={expandedMode ? <ArrowUp1 /> : <ArrowDown />}
      title="All tags"
    />
  );
};
